// Currency symbols map
const CURRENCY_SYMBOLS = {
  KZT: '₸',
  USD: '$',
  EUR: '€',
  RUB: '₽',
  CNY: '¥',
};

// Format currency (default KZT)
export const formatCurrency = (amount, currency = 'KZT') => {
  if (amount == null) return '—';
  const formatted = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
  const symbol = CURRENCY_SYMBOLS[currency] || currency;
  return `${formatted} ${symbol}`;
};

// Format percentage
export const formatPercent = (value) => {
  return `${value.toFixed(1)}%`;
};

// Format date
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('ru-KZ', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);
};

// Format date short
export const formatDateShort = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('ru-KZ', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
};

// Calculate project health status dynamically based on deadline
export const calculateHealthStatus = (deadline, currentStage) => {
  if (!deadline) return 'green';
  
  const deadlineDate = new Date(deadline);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time for accurate comparison
  deadlineDate.setHours(0, 0, 0, 0);
  
  // Check if project is completed
  const isCompleted = currentStage === 'maintenance' || currentStage === 'completed';
  
  if (isCompleted) {
    return 'green'; // Completed projects are always green
  }
  
  // Calculate days remaining
  const daysRemaining = Math.ceil((deadlineDate - today) / (1000 * 60 * 60 * 24));
  
  // CRITICAL (Red): Deadline passed (overdue)
  if (daysRemaining < 0) {
    return 'red';
  }
  
  // RISK (Yellow): Less than 7 days remaining
  if (daysRemaining <= 7) {
    return 'yellow';
  }
  
  // ON TRACK (Green): More than 7 days remaining
  return 'green';
};

// Get health status emoji
export const getHealthEmoji = (status) => {
  switch (status) {
    case 'green':
      return '🟢';
    case 'yellow':
      return '🟡';
    case 'red':
      return '🔴';
    default:
      return '⚪';
  }
};

// Get health status text
export const getHealthText = (status) => {
  switch (status) {
    case 'green':
      return 'В графике';
    case 'yellow':
      return 'Риск';
    case 'red':
      return 'Критично';
    default:
      return 'Неизвестно';
  }
};

// Get stage name in Russian
export const getStageNameRussian = (stageType) => {
  const stages = {
    tender: 'Тендер/Пресейл',
    contract: 'Контрактация',
    procurement: 'Закуп и Логистика',
    installation: 'Монтаж',
    commissioning: 'ПНР',
    acceptance: 'Документация и Сдача',
    maintenance: 'Гарантия/СТО',
  };
  return stages[stageType] || stageType;
};
